import { FileMetadata } from 'hcosmos-api-data'

export function determineFileSize(fileSize: FileMetadata['length'] | number): string {
  if (!fileSize || fileSize <= 0) return ''

  if (fileSize >= 1024 * 1024 * 1024) {
    return (fileSize / (1024 * 1024 * 1024)).toFixed(2) + ' GB'
  }
  if (fileSize >= 1024 * 1024) {
    return (fileSize / (1024 * 1024)).toFixed(2) + ' MB'
  }
  return (fileSize / 1024).toFixed(2) + ' KB'
}